<template>
	<EventLayout :event="event" :subtitle="trans('events.bundles.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-bundle-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Modal id="create-bundle-modal" overflow>
			<template #title>{{ trans('events.bundles.create') }}</template>
			<div class="flex items-end gap-3">
				<Switch v-model.number="form.active" :label="trans('general.enabled')"/>
			</div>
			<LabeledObject required full>
				<template #label>{{ trans('general.title') }}</template>
				<input v-model="form.title" type="text">
			</LabeledObject>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click="create">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<slot/>
	</EventLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import Modal from '@/Components/UI/Modals/Modal.vue'
import EventLayout from '@/Layouts/EventLayout.vue'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
}>()

const event:Ref<Event> = ref(props.event)
const inserting:Ref<boolean> = ref(false)
const form:InertiaForm<Partial<Bundle>> = useForm<Partial<Bundle>>({
	event_id: props.event.id,
	title: '',
	description: '',
	active: false,
})

function create():void{
	if(!inserting.value){
		inserting.value = true
		showInfo(trans('general.inserting'))
		form.post(route('events.bundles.store', event.value.id), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				inserting.value = false
			},
		})
	}
}
</script>